import {Col, Row} from "reactstrap";
import {FormattedMessage} from "react-intl";
import {useSelector} from "react-redux";

import {contactMethodsTypes} from "@utils/types/contactMethodsTypes";
import SectionTitle from "@webViews/components/titles/sectionTitle";
import Map from "@webViews/components/map";
import Form from "./components/form";
import ContactDetails from "./components/contactDetails";
import SocialMedia from "./components/socialMedia";
import ContactUsSkeleton from "./components/skeleton";
import {ContextLayout} from "@layouts/web"

import "./style.scss";
import {useContext, useState} from "react";
import NavigationButton from "../../../../components/buttons/navigationButton";

const ReservationRequest = () => {
    const token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
    const Context = useContext(ContextLayout);
    const [isUserAskedToLogIn, setIsUserAskedToLogIn] = useState(false);
    const addresses = useSelector(state => state.UI.general?.addresses);
    const contactMethods = useSelector(state => state.UI.general?.social_media);

    const phones = contactMethods?.filter(contactMethod => [contactMethodsTypes.phone, contactMethodsTypes.mobile].includes(parseInt(contactMethod.type)));

    const socialMedia = contactMethods?.filter(contactMethod => !phones.includes(contactMethod));

    const showLoginModal = ()=>{
        if (!token) {
            setIsUserAskedToLogIn(true);
            Context?.showLoginModal();
            return;
        }
    }
    return (
        <div className="reservation-request container-costumer my-5 px-1 px-md-5">

            {(!phones || !socialMedia) ?
                <ContactUsSkeleton/>
                :
                <Row  className="reservation-request-content mt-2">

                        <Col xs={12} md={8} className='reservation-request-content-right rounded-lg p-1 p-md-3 d-flex align-items-center justify-content-center' >
                            {
                                token !==  ''?    <Form/> :<div className={"d-flex flex-column align-items-center justify-content-center"}>
                                    <div className="h3">برای ثبت درخواست ابتدا وارد حساب خود شوید.</div>
                                    <NavigationButton
                                        onClick={showLoginModal}
                                        className={"navigation-area-button-multi"}
                                        btnCustom={1}
                                    >
                                        <FormattedMessage id={"loginToAccount"} />
                                    </NavigationButton>
                                </div>
                            }
                        </Col>
                        <Col xs={12} md={4} className='reservation-request-content-left rounded-lg p-3'>
                            <ContactDetails
                                addresses={addresses}
                                phones={phones}
                            />
                            <SocialMedia data={socialMedia}/>
                        </Col>

                </Row>
            }
        </div>
    );
};

export default ReservationRequest;
